module.exports = __webpack_public_path__ + "static/media/silvasa3.50573c28.webp";